(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icraft-esports-partners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('icraft-esports-partners')) {
    customElements.define('icraft-esports-partners', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        const on = (el, name, callback) => el.addEventListener(name, callback, { signal: this.abort.signal });
        this.original = this.querySelector('.iep__list');
        this.copies = [];
        this.viewport = this.querySelector('.iep__viewport');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.frame = 0; this.previous = 0; this.cycle = 0;
        this.tick = time => {
          this.frame = 0;
          const delta = this.previous ? Math.min(time - this.previous, 50) : 0;
          this.previous = time;
          this.position = (this.position + delta * 0.026) % this.cycle;
          this.viewport.scrollLeft = this.position;
          this.frame = requestAnimationFrame(this.tick);
        };
        this.refresh = () => {
          this.cycle = this.original.getBoundingClientRect().width;
          const enabled = !this.motion.matches && this.original.children.length > 1 && this.cycle > 0;
          const count = enabled ? Math.max(1, Math.ceil(this.viewport.clientWidth / this.cycle)) : 0;
          while (this.copies.length > count) this.copies.pop().remove();
          while (this.copies.length < count) {
            const copy = this.original.cloneNode(true);
            copy.classList.add('iep__copy');
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('*').forEach(el => {
              el.removeAttribute('id');
              el.removeAttribute('data-shopify-editor-block');
              if (el.matches('a, button, [tabindex]')) el.tabIndex = -1;
            });
            this.original.parentElement.append(copy);
            this.copies.push(copy);
          }
          this.toggleAttribute('data-loop', enabled);
          const running = enabled && this.visible && !document.hidden;
          this.toggleAttribute('data-running', running);
          if (running && !this.frame) { this.previous = 0; this.position = this.viewport.scrollLeft % this.cycle; this.frame = requestAnimationFrame(this.tick); }
          if (!running) { cancelAnimationFrame(this.frame); this.frame = 0; }
        };
        on(this.motion, 'change', this.refresh);
        on(document, 'visibilitychange', this.refresh);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.refresh(); });
        this.observer.observe(this);
        this.resize = new ResizeObserver(this.refresh);
        this.resize.observe(this.viewport);
        this.resize.observe(this.original);
        this.refresh();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame); this.observer?.disconnect(); this.resize?.disconnect();
        this.abort?.abort(); this.copies?.forEach(copy => copy.remove()); this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
